// src/components/jobPost/StepFooterNav.jsx
import { Button } from "../../ui/button";
import { ArrowRight, ArrowLeft } from "lucide-react";

export function StepFooterNav({
  currentStep,
  totalSteps,
  onBack,
  onNext,
  onBeforeNext,           // NEW optional function
  nextDisabled = false,
  finishText = "Finish",
  backDisabledOnFirstStep = true
}) {
  const isLastStep = currentStep === totalSteps - 1;

  const handleNext = () => {
    // If onBeforeNext exists, run it first
    if (onBeforeNext) {
      const result = onBeforeNext();

      // If it explicitly returns false, block next
      if (result === false) return;
    }

    onNext();
  };

  return (
    <div className="w-full mt-8">
      <div
        className="
          max-w-4xl mx-auto  
          md:justify-between 
          md:flex 
          grid grid-cols-2 gap-3
          md:px-6
        "
      >
        {/* Back button */}
        <Button
          variant="outline"
          onClick={onBack}
          disabled={backDisabledOnFirstStep && currentStep === 0}
          size="lg"
          className="px-8 py-6 flex items-center justify-center w-full md:w-auto"
        >
          <ArrowLeft className="mr-2 w-4 h-4" />
          Go Back
        </Button>

        {/* Next / Finish button */}
        <Button
          onClick={handleNext}
          disabled={nextDisabled}
          size="lg"
          className={`px-8 py-6 flex items-center justify-center w-full md:w-auto
            ${isLastStep ? "bg-primary hover:bg-primary/90" : "bg-secondary hover:bg-gray-800"} 
            text-white`}
        >
          {isLastStep ? finishText : "Continue"}
          {!isLastStep && <ArrowRight className="ml-2 w-4 h-4" />}
        </Button>
      </div>
    </div>
  );
}
